module.exports = __webpack_public_path__ + "img/capture.48ce17b1.svg";